<ng-container *ngFor="let popup of popups">
  <app-mock-call
    [popup]="popup"
    (closeEvent)="onPopupClose(popup.data.busCode)">
  </app-mock-call>
</ng-container>
